import React from 'react';
import { Box } from '@mui/material';
import type { InfoHintProps } from '../../../ui-kit';
import type { ReportTerm } from '../../../types/reportDashboard';

/**
 * What goes behind a term's info icon: what it counts, then — when a nearby
 * field stands in, or nothing records it — how it is worked out instead. Those
 * terms get the yellow icon, so a stand-in is never taken for the real thing.
 */
export function termHint(term: Pick<ReportTerm, 'definition' | 'proxy' | 'missing' | 'source'>): {
  title: React.ReactNode;
  tone: InfoHintProps['tone'];
} {
  const note = term.missing ?? term.proxy;
  const source = term.source ? (
    // Last line, quieter and in the code face: the column or the sum behind the
    // figure, so a reader with warehouse access can check it.
    <Box
      component="span"
      sx={(t) => ({
        display: 'block',
        mt: 0.75,
        fontFamily: t.typography.fontFamilyMono,
        color: t.tokens.text.tertiary,
      })}
    >
      {term.source}
    </Box>
  ) : null;
  if (!note) {
    return { title: <>{term.definition}{source}</>, tone: 'neutral' };
  }
  return {
    title: (
      <>
        {term.definition}
        <Box component="span" sx={{ display: 'block', mt: 0.75 }}>{note}</Box>
        {source}
      </>
    ),
    tone: 'warning',
  };
}
